import React , { Component } from 'react';
import firebase from 'firebase';
import Alert from 'react-s-alert';
import Modal from 'react-modal';
import { sendLog } from '../../util'

const database = firebase.database();

const customStyles = {
	content : {
	  top                   : '50%',
	  left                  : '50%',
	  right                 : 'auto',
	  bottom                : 'auto',
	  transform             : 'translate(-50%, -50%)',
	  width                 : '450px',
	  height: '550px',	 
	  
	}
  };


class ModalTipos extends Component{
	
	
	
	constructor(props){
		
		super(props);
		this.state={
				isActive:false
			
		}
		
		this.tiposVehiculosRef=database.ref().child('Tipos_Vehiculos');
		this.handleSubmit=this.handleSubmit.bind(this);
		
		this.toggleModal=this.toggleModal.bind(this);
		
	}
	
	componentDidMount(){
		
		
	}
	
	componentWillMount(){
		
		Modal.setAppElement('body');
		
	}
	
	toggleModal(){
		
		this.setState({
			
			isActive:!this.state.isActive
			
		})
		
	}
	
	
	handleSubmit(event){
		
		let tipo=this.tipo.value;
		let estado=this.estado.value;
		
		
		
		database.ref().child('Tipos_Vehiculos').orderByChild('tipo').equalTo(tipo).once('value').then(snapshot=>{
					
					if(!snapshot.exists() ){
						
							const  idKey = this.tiposVehiculosRef.push({
				
								tipo:tipo,
								estado:estado
			
							}).key

							sendLog({ tipo: 'tipo_vehiculo_nuevo', informacion_extra: {tipo_vehiculos: idKey} });
							Alert.success('Datos ingresados correctamente', {
								effect: 'genie',
								position: 'bottom-right',
								timeout:2000			
							});
							
							this.toggleModal();
						
					}
					else{
						
						Alert.warning('El tipo de vehiculos a ingresar ya existe', {
								effect: 'genie',
								position: 'bottom-right',
								timeout:2000			
						});
							
						
					}
		});
		
		
		
		event.preventDefault();
	}
	
	
	render(){
		
		return(
		
			<div className="modal_tipos">
					
				<button className="btn btn-primary" onClick={this.toggleModal}><span className="glyphicon glyphicon-plus"> </span> Nuevo</button>
				
				<Modal isOpen={this.state.isActive} onRequestClose={this.toggleModal}  style={customStyles} >
						
					
							<form method="POST" action="" onSubmit={this.handleSubmit}>

									<center><h3>Agregar tipo</h3></center>
									<hr/>
									
									<div className="form-group">
										<label htmlFor="tipo">Tipo de Vehiculo</label>
										<input type="text" name="tipo" className="form-control" placeholder="Tipo de vehiculo"
											ref={input=>{this.tipo=input}}	
											required autoComplete="off"
										/>
									</div>
									

								
									<div className="form-group">
										<label htmlFor="estado">Estado:</label>
										<select className="form-control" name="estado"
										ref={input => {this.estado=input;}}										
										>
										<option>Activo</option>
										<option>Inactivo</option>
										</select>
									</div>
									
								<hr/>
								<button className="btn btn-primary buttons" type="submit" >Guardar</button>
								</form>
								<button className="btn btn-default buttons btnmargin" onClick={this.toggleModal}>Cerrar</button>
					</Modal>
			
			
			
			</div>
		
		)
		
		
	}
	
	
}

export default ModalTipos;


// WEBPACK FOOTER //
// ./src/Components/Vehiculos/ModalTipos.js